import { FC } from "react";
import "./index.css";

type InfoCard = {
  backGroundColor: string;
  fontColor: string;
  type: string;
  action?: () => void;
  isAble?: boolean;
};

const StoreInfoCard: FC<InfoCard> = ({
  backGroundColor,
  fontColor,
  type,
  action,
  isAble,
}) => {
  function typeIcone() {
    switch (type) {
      case "email":
        return emailIcone;
      case "whatsApp":
        return whatsAppIcone;
      case "telefone":
        return telefoneIcone;
    }
  }
  function typeName() {
    switch (type) {
      case "email":
        return "E-mail";
      case "whatsApp":
        return "Whatsapp";
      case "telefone":
        return "Ligar";
    }
  }

  return (
    <div
      className="info-card-Button"
      onClick={() => action && action()}
      style={{
        background: backGroundColor,
        color: fontColor,
        opacity: isAble == undefined ? "" : isAble ? "" : "70%",
      }}
    >
      {typeIcone()}
      <span>{typeName()}</span>
    </div>
  );
};

export { StoreInfoCard };

const whatsAppIcone = (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8906 1.92969C12.0391 3.07812 12.75 4.58203 12.75 6.22266C12.75 9.55859 9.96094 12.293 6.59766 12.293C5.58594 12.293 4.60156 12.0195 3.69922 11.5547L0.5 12.375L1.34766 9.23047C0.828125 8.32812 0.527344 7.28906 0.527344 6.19531C0.527344 2.85938 3.26172 0.125 6.59766 0.125C8.23828 0.125 9.76953 0.78125 10.8906 1.92969ZM6.59766 11.2539C9.38672 11.2539 11.7109 8.98438 11.7109 6.22266C11.7109 4.85547 11.1367 3.59766 10.1797 2.64062C9.22266 1.68359 7.96484 1.16406 6.625 1.16406C3.83594 1.16406 1.56641 3.43359 1.56641 6.19531C1.56641 7.15234 1.83984 8.08203 2.33203 8.90234L2.46875 9.09375L1.94922 10.9531L3.86328 10.4336L4.02734 10.543C4.82031 11.0078 5.69531 11.2539 6.59766 11.2539ZM9.38672 7.48047C9.52344 7.5625 9.63281 7.58984 9.66016 7.67188C9.71484 7.72656 9.71484 8.02734 9.57812 8.38281C9.44141 8.73828 8.83984 9.06641 8.56641 9.09375C8.07422 9.17578 7.69141 9.14844 6.73438 8.71094C5.20312 8.05469 4.21875 6.52344 4.13672 6.44141C4.05469 6.33203 3.53516 5.62109 3.53516 4.85547C3.53516 4.11719 3.91797 3.76172 4.05469 3.59766C4.19141 3.43359 4.35547 3.40625 4.46484 3.40625C4.54688 3.40625 4.65625 3.40625 4.73828 3.40625C4.84766 3.40625 4.95703 3.37891 5.09375 3.67969C5.20312 3.98047 5.53125 4.71875 5.55859 4.80078C5.58594 4.88281 5.61328 4.96484 5.55859 5.07422C5.28516 5.64844 4.95703 5.62109 5.12109 5.89453C5.72266 6.90625 6.29688 7.26172 7.19922 7.69922C7.33594 7.78125 7.41797 7.75391 7.52734 7.67188C7.60938 7.5625 7.91016 7.20703 7.99219 7.07031C8.10156 6.90625 8.21094 6.93359 8.34766 6.98828C8.48438 7.04297 9.22266 7.39844 9.38672 7.48047Z"
      fill="white"
    />
  </svg>
);

const emailIcone = (
  <svg
    width="14"
    height="11"
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.75 1.3125C1.50391 1.3125 1.3125 1.53125 1.3125 1.75V2.37891L6.01562 6.23438C6.58984 6.69922 7.38281 6.69922 7.95703 6.23438L12.6875 2.37891V1.75C12.6875 1.53125 12.4688 1.3125 12.25 1.3125H1.75ZM1.3125 4.07422V8.75C1.3125 8.99609 1.50391 9.1875 1.75 9.1875H12.25C12.4688 9.1875 12.6875 8.99609 12.6875 8.75V4.07422L8.80469 7.24609C7.73828 8.12109 6.23438 8.12109 5.19531 7.24609L1.3125 4.07422ZM0 1.75C0 0.792969 0.765625 0 1.75 0H12.25C13.207 0 14 0.792969 14 1.75V8.75C14 9.73438 13.207 10.5 12.25 10.5H1.75C0.765625 10.5 0 9.73438 0 8.75V1.75Z"
      fill="white"
    />
  </svg>
);

const telefoneIcone = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2539 7.79688L13.3164 9.10938C13.8086 9.30078 14.082 9.82031 13.9727 10.3398L13.3164 13.4023C13.207 13.8945 12.7422 14.2773 12.25 14.2773C12.0586 14.2773 11.8945 14.25 11.7305 14.25C11.457 14.25 11.1836 14.2227 10.9375 14.1953C4.78516 13.5391 0 8.34375 0 2C0 1.50781 0.355469 1.04297 0.847656 0.933594L3.91016 0.277344C4.42969 0.167969 4.94922 0.441406 5.14062 0.933594L6.45312 3.99609C6.64453 4.43359 6.53516 4.95312 6.15234 5.25391L5.03125 6.18359C5.76953 7.44141 6.80859 8.48047 8.06641 9.21875L8.99609 8.09766C9.29688 7.71484 9.81641 7.60547 10.2539 7.79688ZM12.0586 12.9375L12.6328 10.2305L9.89844 9.05469L9.10547 10.0391C8.69531 10.5312 7.98438 10.668 7.41016 10.3398C5.96094 9.49219 4.75781 8.28906 3.91016 6.83984C3.58203 6.26562 3.71875 5.55469 4.21094 5.14453L5.19531 4.35156L4.01953 1.61719L1.3125 2.19141C1.39453 8.09766 6.15234 12.8555 12.0586 12.9375Z"
      fill="white"
    />
  </svg>
);
